import { getLocalByLocalId } from '../../../crud/management_api/locales';
import { getLocalConfigurationByLocalId } from '../../../crud/management_api/local_configurations';
import { getUserPermissions } from '../../../crud/users_api/user_permissions';

// This function is now asynchronous and can handle errors effectively.
// It should receive `setLoading` and `setError` to control the flow of the app.

export async function loadContext(setLoading: (loading: boolean) => void, setError: (error: string | null) => void) {
  try {
    setLoading(true);
    const user = JSON.parse(localStorage.getItem('user') || '{}');

    if (!user) {
      return false;
    }

    const localId = user ? user.local_id : 0;

    if (!localId) {
      console.log('No se pudo cargar la tabla de precios, no se encontró el localId');
      return false
    }

    // Fetch all data asynchronously in parallel
    const [
      localResponse,
      localConfigResponse,
      userPermissionsResponse,
    ] = await Promise.all([
      getLocalByLocalId(localId),
      getLocalConfigurationByLocalId(localId),
      getUserPermissions(user.user_id),
    ]);

    // Set data into localStorage
    localStorage.setItem('local', JSON.stringify(localResponse.data));
    localStorage.setItem('localConfiguration', JSON.stringify(localConfigResponse.data));
    
    // Add timestamp before storing user permissions
    const userPermissionsWithTimestamp = {
      ...userPermissionsResponse.data,
      lastLoaded: Date.now()
    };
    localStorage.setItem('userPermissions', JSON.stringify(userPermissionsWithTimestamp));
    
    // Clear any previous errors
    setError(null);
    return true
  } catch (error: any) {
    console.error('Error loading context data:', error);
    setError(error.message || 'Ocurrió un error al cargar los datos');
    return false;
  } finally {
    setLoading(false);
  }
}